import { render, staticRenderFns } from "./PaymentStudentServices.vue?vue&type=template&id=d35d9d66&scoped=true"
import script from "./PaymentStudentServices.vue?vue&type=script&lang=js"
export * from "./PaymentStudentServices.vue?vue&type=script&lang=js"
import style0 from "./PaymentStudentServices.vue?vue&type=style&index=0&id=d35d9d66&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35d9d66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d35d9d66')) {
      api.createRecord('d35d9d66', component.options)
    } else {
      api.reload('d35d9d66', component.options)
    }
    module.hot.accept("./PaymentStudentServices.vue?vue&type=template&id=d35d9d66&scoped=true", function () {
      api.rerender('d35d9d66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/jornalPayment/components/details/PaymentStudentServices.vue"
export default component.exports